import React from 'react';
import { GenericStars } from '@wix/ftsystem';
import { DATA_RATING } from '../../../common/constants/data-attributes';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { RATING_DISPLAY } from '../../../common/constants/data-hooks';
import { StarIcon } from './star-icon';
import { classes, st } from './ratings-display.st.css';
const SmallStars = GenericStars({ Icon: StarIcon, gap: 'small' });
export const RatingsDisplay = ({ className, rating = 0, isPending = false, }) => {
    const t = useTranslate();
    return (React.createElement("div", Object.assign({ "data-hook": RATING_DISPLAY }, { [DATA_RATING]: rating }),
        React.createElement(SmallStars, { className: st(classes.root, {
                isPending,
            }, className), a11yLabel: t('ratings-display.rating-aria-label', { rating }), rating: rating })));
};
//# sourceMappingURL=ratings-display.js.map